import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { GET_TWEET_VERSION, logError, logDebugMessage } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function getTweetVersion(action$, state$) {
    return action$.pipe(ofType(GET_TWEET_VERSION), mergeMap(function(action) {
        return from(SocialAPIUtils.getTweetVersion()).pipe(switchMap(function(version) {
            return [
                logDebugMessage({
                    message: version,
                    messageType: "info",
                    label: "ENGAGEMENT_VERSION"
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "get_tweet_version"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "get_tweet_version"
        }));
    }));
}
